module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_c('i', [_vm._v("Foreword")]), _vm._v(" by Werner H. Kelber")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Exegetical Kaleidoscope:"), _c('br'), _vm._v("Images of the Genesis and Interpretation of Mark’s Gospel")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s1"
    }
  }, [_vm._v("Starting Point: Farewell to Traditional Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s2"
    }
  }, [_vm._v("Of Episodes and Frames: "), _c('i', [_vm._v("Formgeschichte")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s3"
    }
  }, [_vm._v("From Tradent to Theologian: Redaction History")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s4"
    }
  }, [_vm._v("Evolutionary Synoptic Growth? Orality, Scribality, and the Memory Approach")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s5"
    }
  }, [_vm._v("Look into the Text, Not behind the Text: Narrative Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s6"
    }
  }, [_vm._v("History or Stories?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001a#s7"
    }
  }, [_vm._v("The Return of the Eyewitnesses")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001a#s8"
    }
  }, [_vm._v("Interpreted Experience: Gospels as Collective Memories")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001a#s9"
    }
  }, [_vm._v("The Goal of This Study")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part001#pt001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK’S")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL AND")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIAL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMORY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Social Recollection:"), _c('br'), _vm._v("The Construction of Memory Texts in Collective Memories")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Constructive Character of Recollection and Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Narration as the Basic Structure of Memory Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002a#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forms of Social Recollection and Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Mark’s Gospel as a Memory Text")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark’s Gospel as a Memory Text—a Model for Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observations Gained from the Whole Text of Mark’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMORIES AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DENTITY")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMATION IN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK 6:7–8:26")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Structure of the Text and Its Orientation toward Available Patterns")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of the Text")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orientation toward Available Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Guiding Perspective")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Narrative Formation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preliminary Remarks on Hermeneutics and Method")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perspectives and Worlds in Mark 6:7–8:26")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intermediary Result")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Transparency for the Community of Narration and Invitation to Engagement")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preliminary Remarks on Hermeneutics and Method")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Individual Aspects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invitation to Engagement")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Prospects")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "eps1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hermeneutical and Methodological Reconsiderations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "eps2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "eps3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memory Approaches: A Changed Landscape")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "eps4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Questions and Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture Citations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index004#idx004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Other Ancient Sources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0